import { ServerPasteParams } from '../types/types';

type I18nKey = 'muteVideo' | 'autoplayVideo';

export const serverPasteParamsCheckboxes: [ServerPasteParams, I18nKey][] = [
    ['mute', 'muteVideo'],
    ['autoplay', 'autoplayVideo'],
];
